import { dataJSON} from "@/services/ApiServer";

export default {
    getAll() {
        return dataJSON;
    },



};